import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {VendorService} from '../../../shared/services/vendors/vendor.service';
import {NotificationService} from '../../../shared/services/notification/notification.service';
import {AppConstant} from '../../../shared/utility/app-constant';

@Component({
  selector: 'app-request-resend',
  templateUrl: './request-resend.component.html',
  styleUrls: ['./request-resend.component.scss']
})
export class RequestResendComponent implements OnInit {

  message = 'Loading...';
  headerMessage = 'Loading...';

  constructor(public activatedRoute: ActivatedRoute, private vendorService: VendorService,
              private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    this.vendorService.resendAchRequestMail(this.activatedRoute.snapshot.queryParams.id).subscribe(res => {
        if (res.status == AppConstant.HTTP_RESPONSE_STATUS_SUCCESS) {
          this.headerMessage = 'Success!';
          this.message = 'A new ACH information request has been successfully sent...';
        } else {
          this.headerMessage = 'Attention!';
          this.message = 'ACH information request already sent.';
        }
      },
      () => {
        this.headerMessage = 'Oops!';
        this.message = 'System error exist, Please contact administrator for more details.';
      });
  }

}
